export enum StepName {
  store = 'store',
  material = 'material',
  color = 'color',
  designShape = 'designShape',
  designEdge = 'designEdge',
  designCornerRadius = 'designCornerRadius',
  designDiagonalCorner = 'designDiagonalCorner',
  designCustomSide = 'designCustomSide',
  designSink = 'designSink',
  designCookingAppliance = 'designCookingAppliance',
  designCutout = 'designCutout',
  designPlumbing = 'designPlumbing',
  designTearOut = 'designTearOut',
  designAddOn = 'designAddOn',
  orderSummary = 'orderSummary',
  thankYou = 'thankYou',
}

export type PageStepName =
  | StepName.store
  | StepName.material
  | StepName.color
  | StepName.designShape
  | StepName.orderSummary
  | StepName.thankYou;

export type RequiredStepName = Omit<PageStepName, StepName.thankYou>;

export type DesignStepName =
  | StepName.designShape
  | StepName.designEdge
  | StepName.designCornerRadius
  | StepName.designDiagonalCorner
  | StepName.designCustomSide
  | StepName.designSink
  | StepName.designCookingAppliance
  | StepName.designCutout
  | StepName.designTearOut
  | StepName.designAddOn
  | StepName.designPlumbing;
